import { cn } from '@app/utils/cn';
import { handleSpaceAndEnter } from '@app/utils/handleEnterKey';
import React from 'react';

import { ContentPlaceholder } from '../Icons';

interface Props {
  aspectRatio: number;
  className?: string;
  shouldShowIcon?: boolean;
  onClick?: () => void;
  role?: string;
}

export const Placeholder = React.memo(
  ({ aspectRatio, children, className, shouldShowIcon = false, onClick, role }: React.WithOptionalChildren<Props>) => {
    const style = React.useMemo(() => ({ paddingTop: `calc(${aspectRatio} * 100%)` }), [aspectRatio]);

    return (
      <div
        onClick={onClick}
        onKeyDown={handleSpaceAndEnter(onClick)}
        role={role}
        className={cn('relative w-full', className)}
        style={style}
      >
        <div className="absolute inset-0 flex select-none flex-col items-center justify-center overflow-hidden whitespace-nowrap text-center text-neutral-80 body-6">
          {shouldShowIcon && <ContentPlaceholder className="size-10" />}
          {children}
        </div>
      </div>
    );
  },
);
